<div class="container-fluid">
    <div class="search-job-container">
        <div class="row justify-content-center">
            <div class="col-12">
                <filter-search-job [isHome]="false" [urlFilters]="urlFilters" (filtrosChange)="onFiltrosChange($event)"></filter-search-job>
            </div>
        </div>
        <div class="row mt-3 justify-content-center search-results-section">
            <div class="col-12 col-sm-12 col-md-4">
                <div class="row">
                    <div class="col-12">
                        <p class="text-muted mb-2">
                          <strong class="text-primary">{{listJobOpening.length}}</strong> {{'result' | translate}}
                        </p>
                    </div>
                </div>
                <div class="row search-left-scroll">
                    <div *ngIf="listJobOpening.length === 0 && !busquedaFinalizo">
                      <div class="px-3 py-3">
                          <div *ngFor="let i of [1,2,3,4]" class="skeleton-card mb-3 p-3 rounded border bg-light">
                            <div class="d-flex justify-content-between align-items-start mb-2">
                              <div class="skeleton-logo"></div>
                              <div class="skeleton-line short"></div>
                            </div>
                            <div class="skeleton-text mb-3 w-75"></div>
                            <div class="skeleton-pill mb-3"></div>

                            <div class="skeleton-line mb-2 w-50"></div>
                            <div class="skeleton-line w-25"></div>
                          </div>
                        </div>
                    </div>
                    <!-- Lista de vacantes -->
                    <div class="col-12 mt-3">
                      <div class="vacancy-list">
                        <div class="job-card p-3 mb-3 shadow-sm hover-active" *ngFor="let jobOpening of listJobOpening; let i = index" [ngClass]="{'card-job-selected': i===indexJobSelected}" (click)="jobOpeningClick(i,jobOpening._source.id!)">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <img src="/assets/img/home/Manpower/mp logo.png" height="20" alt="logo" /> 

                                <small class="text-muted fw-medium">#{{jobOpening._source.id}} - {{jobOpening._source.createdOn | date:'longDate'}}</small>
                              </div>
                              <h6 class="fw-bold text-primary mb-2">{{jobOpening?._source?.name}}</h6>
                              
                              <div class="badge-salary mb-2" *ngIf="!jobOpening._source.ocultar_sueldo">
                                <div *ngIf="jobOpening?._source?.datosContratacion?.[0]?.sueldo as sueldo; else defaultSueldo">
                                  {{ formatoMoneda(sueldo) }}
                                </div>
                                <ng-template #defaultSueldo>
                                  {{ formatoMoneda(jobOpening?._source?.sueldo_min) || '—' }}
                                  -
                                  {{ formatoMoneda((jobOpeningSelected ?? jobOpening)?._source?.sueldo_mx) || '—' }}
                                </ng-template>
                              </div>
                              <div class="badge-salary mb-2" *ngIf="jobOpening._source.ocultar_sueldo">
                                Sueldo no especificado
                              </div>
                              <ul class="list-unstyled text-muted small mb-0">
                                <li><i class="bi bi-geo-alt me-1"></i> {{getUbicacion(jobOpening?._source?.ubicacion)}}</li>
                                <li><i class="bi bi-calendar-week me-1"></i> {{getHorarioTrabajo(jobOpening?._source?.horario_trabajo)}}</li>
                                <li><i class="bi bi-briefcase me-1"></i> {{jobOpening?._source?.categoria}}</li>
                              </ul>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-8">
                <div class="job-detail bg-white p-4 rounded-4 shadow-sm">
                    <div class="d-flex justify-content-between align-items-start mb-3">

                        <div class="alert alert-secondary d-flex align-items-start gap-3 p-3 rounded-4 shadow-sm" role="alert" *ngIf="isEmpty(jobOpeningSelected) && busquedaFinalizo">
                          <i class="bi bi-info-circle-fill text-secondary fs-4"></i>
                          <div>
                            <strong class="d-block">No se encontraron vacantes con los filtros de búsqueda seleccionados.</strong>
                            <span class="text-muted">
                              Te invitamos a volver a consultar próximamente o ajustar tus filtros de búsqueda.
                            </span>
                          </div>
                        </div>
                        <div *ngIf="!isEmpty(jobOpeningSelected)" class="container">
                            <!-- Detalle de la vacante -->
                            <div class="d-flex justify-content-between align-items-start mb-3 container-fluid">
                              <div class="col-9">
                                <img src="/assets/img/home/Manpower/mp logo.png" height="20" class="mb-2">
                                <h5 class="fw-bold text-primary mb-1">{{jobOpeningSelected?.name}}</h5>
                                <small class="text-muted">#{{jobOpeningSelected?.id}} - {{jobOpeningSelected?.createdOn | date:'longDate'}}</small>
                              </div>
                              <div class="col-3 text-end">
                                <button class="btn btn-outline-secondary btn-sm me-2" [disabled]="!jobOpeningSelected" (click)="openShareModal()"><i class="bi bi-share"></i></button>
                                <button class="btn btn-primary btn-sm rounded-pill" [disabled]="!jobOpeningSelected" (click)="goToJobApply()">{{'apply' | translate}}</button>
                              </div>
                            </div>

                            <!-- Modal -->
                            <div #modalCompartir  class="modal fade" tabindex="-1">
                                <div class="modal-dialog">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Compartir enlace</h5>
                                            <button type="button" class="btn-close"
                                                data-bs-dismiss="modal"></button>
                                        </div>
                                        <div class="modal-body">
                                            <input type="text" class="form-control" [value]="enlace" readonly>
                                            <button class=" btn button-nm  btn-primary mt-2 w-100" (click)="copiarEnlace()">
                                                Copiar enlace
                                            </button>
                                            <p class="text-success mt-2" *ngIf="mensaje">{{ mensaje }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="badge-salary mb-3" *ngIf="!jobOpeningSelected?.ocultar_sueldo">
                              <div *ngIf="jobOpeningSelected?.datosContratacion?.[0]?.sueldo as sueldo; else defaultSueldo">
                                  {{ formatoMoneda(sueldo) }}
                                </div>

                                <ng-template #defaultSueldo>
                                  {{ formatoMoneda(jobOpeningSelected.sueldo_min) || '—' }} - {{ formatoMoneda(jobOpeningSelected.sueldo_mx) || '—' }}
                                </ng-template>
                            </div>
                            <div class="badge-salary mb-3" *ngIf="jobOpeningSelected?.ocultar_sueldo">
                                Sueldo no especificado
                            </div>

                            <div class="text-muted mb-2">
                              <i class="bi bi-geo-alt me-1"></i> {{getUbicacion(jobOpeningSelected?.ubicacion)}}
                            </div>

                            <hr />

                            <h6 class="fw-semibold text-dark mb-2">Detalles de la vacante</h6>
                            <ul class="list-unstyled small text-muted mb-3">
                                <li>
                                    <i class="bi bi-clipboard-check me-1"></i>Horario: {{getHorarioTrabajo(jobOpeningSelected?.horario_trabajo)}} 
                                </li>
                                <li>
                                    <i class="bi bi-calendar3 me-1"></i> {{getLugarTrabajo(jobOpeningSelected?.lugar_trabajo)}}
                                </li>

                                <li>
                                    <i class="bi bi-spellcheck"></i> Idioma: <span *ngIf="!isJson(jobOpeningSelected?.idiomas)">{{jobOpeningSelected?.idiomas}}</span>
                                </li>
                                <li>
                                    <i class="bi bi-mortarboard-fill"></i> Estudios: {{getEscolaridad(jobOpeningSelected?.escolaridad)}}
                                </li>
                                <li>
                                    <i class="bi bi-people-fill"></i> Experiencia: {{jobOpeningSelected?.experiencia}}
                                </li>
                                <li>
                                    <i class="bi bi-briefcase-fill"></i> Categoría: {{jobOpeningSelected?.categoria}}
                                </li>
                            </ul>

                            <h6 class="fw-semibold text-dark">{{'description' |translate}}</h6>
                            <p class="small text-muted" [innerHTML]="getFormattedText(jobOpeningSelected?.description)"></p>

                            <h6 class="fw-semibold text-dark" *ngIf="jobOpeningSelected?.obligatorias">Requisitos obligatorios</h6>
                            <p class="small text-muted" [innerHTML]="getFormattedText(jobOpeningSelected?.obligatorias)" *ngIf="jobOpeningSelected?.obligatorias"></p>

                            <h6 class="fw-semibold text-dark" *ngIf="jobOpeningSelected?.opcionales">Requisitos opcionales</h6>
                            <p class="small text-muted" [innerHTML]="getFormattedText(jobOpeningSelected?.opcionales)" *ngIf="jobOpeningSelected?.opcionales"></p>

                            <h6 class="fw-semibold text-dark" *ngIf="jobOpeningSelected?.deseables">Requisitos deseables</h6>
                            <p class="small text-muted" [innerHTML]="getFormattedText(jobOpeningSelected?.deseables)" *ngIf="jobOpeningSelected?.deseables"></p>

                            <h6 class="fw-semibold text-dark" *ngIf="jobOpeningSelected?.validaciones">Validaciones</h6>
                            <p class="small text-muted" [innerHTML]="getFormattedText(jobOpeningSelected?.validaciones)" *ngIf="jobOpeningSelected?.validaciones"></p>

                            <h6 class="fw-semibold text-dark" *ngIf="jobOpeningSelected?.beneficios">Beneficios</h6>
                            <p class="small text-muted" [innerHTML]="getFormattedText(jobOpeningSelected?.beneficios)" *ngIf="jobOpeningSelected?.beneficios"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<section class="banner-inclusion text-white text-center py-5">
  <div class="container px-4">
    <h2 class="fw-bold mb-3">
      En ManpowerGroup creamos espacios laborales incluyentes donde lo que se busca es el talento y las competencias de las personas sin importar sus características individuales
    </h2>
    <p class="lead">
      como sexo, edad, orientación sexual, identidad o expresión de género, nacionalidad, situación migratoria, apariencia física, discapacidad, idioma, condición social o económica, de salud o jurídica, embarazo, estado civil o conyugal, religión, opiniones, expresión física, diversidad corporal, afiliación política, presencia de tatuajes visibles o no, otras modificaciones corporales, u otra condición que pueda considerarse.
    </p>
  </div>
</section>